import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="auth-container">
      <div class="auth-card">
        <h2>Signing you in...</h2>
        <p *ngIf="!error">Please wait while we complete authentication.</p>
        <p class="error-message" *ngIf="error">{{ error }}</p>
      </div>
    </div>
  `,
  styles: [`
    .auth-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #121212;
      color: #fff;
    }
    .auth-card {
      background-color: #1e1e1e;
      padding: 2rem;
      border-radius: 8px;
      width: 100%;
      max-width: 420px;
      text-align: center;
    }
    .error-message {
      color: #ff5252;
      margin-top: 0.75rem;
    }
  `],
})
export class AuthCallbackComponent implements OnInit {
  error = '';

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/sessions';

    try {
      await this.authService.handleAuthCallback();
      await this.router.navigateByUrl(returnUrl);
    } catch (error: any) {
      // Avoid flashing transient callback errors during fast redirects.
      await new Promise((resolve) => setTimeout(resolve, 250));
      this.error = error?.message || 'Authentication callback failed';
    }
  }
}
